<template>
  <div class="blk_facility">
    <h3 class="facility_header"><span>POINT 0{{ idx + 1 }}</span></h3>
    <div class="facility_image">
      <img :src="imgSrc" alt="">
      <p class="facility_summary"><span v-html="copy"></span></p>
    </div>
    <p class="facility_discription" v-html="text"></p>
    <div class="recommend">
      <p class="h_deco h_fan">こんな方におすすめ！</p>
      <ul class="list list_circle">
        <li v-for="list in lists">{{ list }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Facility',
  props: {
    msg: String,
    copy: String,
    text: String,
    lists: Array,
    idx: Number
  },
  data () {
    return {
      imgSrc: `/assets/img/home/img_point_0${this.idx + 1}.png`
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
